<p-toast></p-toast>
<p-confirmDialog [style]="{ width: '32rem' }"></p-confirmDialog>

<div class="page">
  <!-- Header -->
  <div class="header-card">
    <div class="header-card__left">
      <i class="fa-solid fa-sliders"></i>
      <div>
        <h1>Algoritmo de ofertas</h1>
        <p>Los parámetros con los que se calcula la capacidad, la tasa y el plazo de cada arrendamiento. Cada versión queda registrada y cada verificación guarda con cuál se calculó.</p>
      </div>
    </div>
    <button pButton type="button" class="p-button-success" icon="fa-solid fa-plus" label="Nueva versión" (click)="nueva()"></button>
  </div>

  <!-- KPIs de la versión activa -->
  <div class="kpis" *ngIf="active as a">
    <div class="kpi">
      <span class="kpi-val">v{{ a.version }}</span>
      <span class="kpi-lbl">Versión activa</span>
    </div>
    <div class="kpi">
      <span class="kpi-val money">{{ a.params.rateTable.baseRate }}%</span>
      <span class="kpi-lbl">Tasa base</span>
    </div>
    <div class="kpi">
      <span class="kpi-val">{{ a.params.baseCapacity.netIncomeMonths }}</span>
      <span class="kpi-lbl">Meses de utilidad</span>
    </div>
    <div class="kpi">
      <span class="kpi-val">{{ (a.params.conservativeOffer.minAmountFactor * 100) | number:'1.0-0' }}%</span>
      <span class="kpi-lbl">Oferta conservadora</span>
    </div>
    <div class="kpi">
      <span class="kpi-val">{{ a.params.riskMultipliers.score.defaultScore }}</span>
      <span class="kpi-lbl">Score por defecto</span>
    </div>
  </div>

  <!-- Loading -->
  <div class="info-card" *ngIf="cargando">
    <div class="card-content">
      <p-skeleton height="2rem" styleClass="mb-2"></p-skeleton>
      <p-skeleton height="2rem" styleClass="mb-2"></p-skeleton>
      <p-skeleton height="2rem"></p-skeleton>
    </div>
  </div>

  <!-- Error de carga: estado propio, no una tabla vacía -->
  <div class="estado" *ngIf="!cargando && errorCarga">
    <i class="fa-solid fa-triangle-exclamation estado__icon estado__icon--warn"></i>
    <h3>No se pudo cargar el historial</h3>
    <p>{{ errorCarga }}</p>
    <button pButton type="button" class="p-button-outlined" icon="fa-solid fa-rotate-right" label="Reintentar" (click)="cargar()"></button>
  </div>

  <!-- Sin versiones: estado propio, fuera de la tabla -->
  <div class="estado" *ngIf="!cargando && !errorCarga && !configs.length">
    <i class="fa-solid fa-sliders estado__icon"></i>
    <h3>Todavía no hay versiones</h3>
    <p>
      Aquí queda registrado cada juego de parámetros con el que se han calculado ofertas: quién lo creó, por qué y
      desde cuándo está vigente. Crea la primera para empezar.
    </p>
    <button pButton type="button" class="p-button-success" icon="fa-solid fa-plus" label="Nueva versión" (click)="nueva()"></button>
  </div>

  <!-- Tabla -->
  <div class="info-card" *ngIf="!cargando && !errorCarga && configs.length">
    <div class="card-header">
      <i class="fa-solid fa-clock-rotate-left"></i>
      <h3>Historial de versiones</h3>
    </div>
    <div class="card-content">
      <p-table [value]="configs" [rows]="15" [paginator]="configs.length > 15" styleClass="p-datatable-sm" [rowHover]="true">
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 5rem">Versión</th>
            <th>Nombre</th>
            <th style="width: 8rem">Estado</th>
            <th>Motivo del cambio</th>
            <th style="width: 10rem">Responsable</th>
            <th style="width: 9rem">Fecha</th>
            <th style="width: 9rem"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-c>
          <tr (click)="abrir(c)" class="fila">
            <td>
              <span class="version">v{{ c.version }}</span>
              <i class="fa-solid fa-lock ancla" *ngIf="c.isSystemDefault" pTooltip="Configuración histórica: es el ancla de comparación, no se edita ni se borra" tooltipPosition="right"></i>
            </td>
            <td>
              <span class="nombre">{{ c.name }}</span>
              <span class="derivada" *ngIf="c.derivedFromVersion"> · derivada de v{{ c.derivedFromVersion }}</span>
            </td>
            <td><p-tag [value]="etiquetaEstado(c.status)" [severity]="severidadEstado(c.status)"></p-tag></td>
            <td class="motivo">{{ c.changeReason }}</td>
            <td class="meta">{{ autor(c) }}</td>
            <td class="meta">{{ (c.activatedAt || c.createdAt) | date:'dd/MM/yyyy HH:mm' }}</td>
            <td class="acciones">
              <button pButton type="button" class="p-button-text p-button-sm" icon="fa-solid fa-eye"
                      (click)="abrir(c); $event.stopPropagation()" pTooltip="Ver" tooltipPosition="top"></button>
              <button pButton type="button" class="p-button-text p-button-sm p-button-success" icon="fa-solid fa-circle-check"
                      *ngIf="c.status === 'draft'" (click)="activar(c, $event)" pTooltip="Activar" tooltipPosition="top"></button>
              <button pButton type="button" class="p-button-text p-button-sm p-button-danger" icon="fa-solid fa-trash"
                      *ngIf="c.status === 'draft' && !c.isSystemDefault" (click)="borrar(c, $event)" pTooltip="Borrar" tooltipPosition="top"></button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
